/*
 * @Author: 张天昊
 * @Date: 2024-05-23 10:01:28
 * @LastEditTime: 2024-05-23 15:12:21
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/pages/itineraryUniversal/composables/useTabsLineWidth.js
 */
import { onMounted, ref, unref, nextTick } from 'vue';
export function useTabsLineWidth(instance) {
  /**
   * 动态计算tab文本节点宽度
   */
  const lineWidth = ref('0');
  onMounted(resizeLineWidth);
  function resizeLineWidth() {
    const instanceValue = unref(instance);
    nextTick(() => {
      if (instanceValue && instanceValue.$children.length) {
        const currentTabElem = instanceValue.$children[0].$children
          .map((item) => item.$el)
          .find((item) => item.classList.contains('van-tab--active'));
        if (currentTabElem) {
          const textNode = currentTabElem.firstElementChild;
          if (textNode) {
            const textNodeWidth = window.getComputedStyle(textNode).width;
            lineWidth.value = textNodeWidth;
            instanceValue.resize();
          }
        }
      }
    });
  }

  return {
    lineWidth,
    resizeLineWidth
  }
}
